<div class="text-center mb-3">
  <span class="material-icons display-2">cached</span>
</div>
<div class="text-center">
  <div mat-dialog-content>Trwa zapisywanie zmiany</div>
</div>
